export { BaselineComponent } from './baseline.component';
export { remediate } from './remediate';
export const href = 'https://learn.microsoft.com/en-us/graph/api/resources/voiceauthenticationmethodconfiguration';
